import React from 'react';

const Input = ({
   label,
   type = 'text',
   name,
   value,
   onChange,
   placeholder,
   error,
   required = false,
   className = '',
   ...props
}) => {
   return (
      <div className="">
         {label && (
            <label
               htmlFor={name}
               className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
            >
               {label}
               {required && <span className="text-red-500 dark:text-red-400 ml-1">*</span>}
            </label>
         )}
         <input
            type={type}
            id={name}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className={`w-full px-4 py-2 border rounded-lg bg-white dark:bg-dark-primary text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-dark-accent focus:border-transparent cursor-pointer ${error ? 'border-red-500 dark:border-red-400' : 'border-gray-300 dark:border-gray-600'} ${className}`}
            {...props}
         />
         {error && <p className="mt-1 text-sm text-red-500 dark:text-red-400">{error}</p>}
      </div>
   );
};

export default Input;
